import {
  getAttendance as publicGetAttendance,
  setAttendance as publicSetAttendance,
  bulkSetAttendance as publicBulkSetAttendance,
  queryAttendance as publicQueryAttendance,
  typedQueryAttendance as publicTypedQueryAttendance,
  countAttendances as publicCountAttendances,
  deleteAttendance as publicDeleteAttendance,
  bulkDeleteAttendances as publicBulkDeleteAttendances,
} from './bookings-v2-attendance-attendance.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  AttendanceQuery,
  AttendancesQueryBuilder,
  typedQueryAttendance as universalTypedQueryAttendance,
} from './bookings-v2-attendance-attendance.universal.js';
import { onAttendanceDeleted as publicOnAttendanceDeleted } from './bookings-v2-attendance-attendance.public.js';

function customQueryAttendance(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryAttendance(httpClient)(),
    typedQueryFunction: (query: AttendanceQuery) =>
      publicTypedQueryAttendance(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): AttendancesQueryBuilder;
  function overloadedQuery(
    query: AttendanceQuery
  ): ReturnType<typeof universalTypedQueryAttendance>;
  function overloadedQuery(query?: AttendanceQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const getAttendance: MaybeContext<
  BuildRESTFunction<typeof publicGetAttendance> & typeof publicGetAttendance
> = /*#__PURE__*/ createRESTModule(publicGetAttendance);
export const setAttendance: MaybeContext<
  BuildRESTFunction<typeof publicSetAttendance> & typeof publicSetAttendance
> = /*#__PURE__*/ createRESTModule(publicSetAttendance);
export const bulkSetAttendance: MaybeContext<
  BuildRESTFunction<typeof publicBulkSetAttendance> &
    typeof publicBulkSetAttendance
> = /*#__PURE__*/ createRESTModule(publicBulkSetAttendance);
export const countAttendances: MaybeContext<
  BuildRESTFunction<typeof publicCountAttendances> &
    typeof publicCountAttendances
> = /*#__PURE__*/ createRESTModule(publicCountAttendances);
export const deleteAttendance: MaybeContext<
  BuildRESTFunction<typeof publicDeleteAttendance> &
    typeof publicDeleteAttendance
> = /*#__PURE__*/ createRESTModule(publicDeleteAttendance);
export const bulkDeleteAttendances: MaybeContext<
  BuildRESTFunction<typeof publicBulkDeleteAttendances> &
    typeof publicBulkDeleteAttendances
> = /*#__PURE__*/ createRESTModule(publicBulkDeleteAttendances);
export const queryAttendance: MaybeContext<
  BuildRESTFunction<typeof customQueryAttendance> & typeof customQueryAttendance
> = /*#__PURE__*/ createRESTModule(customQueryAttendance);
/** */
export const onAttendanceDeleted: BuildEventDefinition<
  typeof publicOnAttendanceDeleted
> &
  typeof publicOnAttendanceDeleted = createEventModule(
  publicOnAttendanceDeleted
);

export {
  AttendanceStatus,
  SortOrder,
  WebhookIdentityType,
} from './bookings-v2-attendance-attendance.universal.js';
export {
  Attendance,
  GetAttendanceRequest,
  GetAttendanceResponse,
  SetAttendanceRequest,
  ParticipantNotification,
  SetAttendanceResponse,
  AttendanceMarkedAsNotAttended,
  BulkSetAttendanceRequest,
  AttendanceDetails,
  BulkSetAttendanceResponse,
  BulkAttendanceResult,
  ItemMetadata,
  ApplicationError,
  BulkActionMetadata,
  QueryAttendanceRequest,
  QueryV2,
  QueryV2PagingMethodOneOf,
  Sorting,
  Paging,
  CursorPaging,
  QueryAttendanceResponse,
  CursorPagingMetadata,
  Cursors,
  CountAttendancesRequest,
  CountAttendancesResponse,
  DeleteAttendanceRequest,
  DeleteAttendanceResponse,
  BulkDeleteAttendancesRequest,
  BulkDeleteAttendancesResponse,
  BulkDeleteAttendancesResult,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  AttendanceDeletedEnvelope,
  SetAttendanceOptions,
  BulkSetAttendanceOptions,
  AttendancesQueryResult,
  AttendancesQueryBuilder,
  AttendanceQuerySpec,
  CountAttendancesOptions,
} from './bookings-v2-attendance-attendance.universal.js';
export { utils } from './bookings-v2-attendance-attendance.universal.js';
export {
  AttendanceStatusWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  GetAttendanceApplicationErrors,
  SetAttendanceApplicationErrors,
  BulkSetAttendanceApplicationErrors,
  DeleteAttendanceApplicationErrors,
  CommonQueryWithEntityContext,
  AttendanceQuery,
} from './bookings-v2-attendance-attendance.universal.js';
